import React from 'react'

function Header() {
  return (
    <div className='header-container'>
      <h3>Your Record Crate</h3>
    </div>
  )
}

export default Header